import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';

import {
  CreateFacilityPositionDto,
  FacilityPositionDto,
  UpdateFacilityPositionDto,
} from '../dtos';
import { FacilityContextService } from './facility-context.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FacilityPositionsService {
  private http = inject(HttpClient);
  private facilityContext = inject(FacilityContextService);

  private readonly baseUrl = computed(
    () => `/api/Facilities/${this.facilityContext.facilityId()}`
  );
  // ============================================
  // ENDPOINT 24: GET /api/facilities/{id}/positions
  // Get all positions for a facility
  // ============================================
  getAll(): Observable<FacilityPositionDto[]> {
    return this.http.get<FacilityPositionDto[]>(`${this.baseUrl()}/positions`);
  }

  // ============================================
  // ENDPOINT 25: GET /api/facilities/{id}/positions/{positionId}
  // Get a specific position by IDthis.baseUrl
  // ============================================
  get(positionId: number): Observable<FacilityPositionDto> {
    return this.http.get<FacilityPositionDto>(
      `${this.baseUrl()}/positions/${positionId}`
    );
  }

  // ============================================
  // ENDPOINT 26: POST /api/facilities/{id}/positions
  // Create a new position for a facility
  // ============================================
  create(body: CreateFacilityPositionDto): Observable<FacilityPositionDto> {
    return this.http.post<FacilityPositionDto>(
      `${this.baseUrl()}/positions`,
      body
    );
  }

  // ============================================
  // ENDPOINT 27: PUT /api/facilities/{id}/positions/{positionId}
  // Update a facility position
  // ============================================
  update(
    positionId: number,
    body: Partial<UpdateFacilityPositionDto>
  ): Observable<FacilityPositionDto> {
    return this.http.put<FacilityPositionDto>(
      `${this.baseUrl()}/positions/${positionId}`,
      body
    );
  }

  // ============================================
  // ENDPOINT 28: DELETE /api/facilities/{id}/positions/{positionId}
  // Delete a facility position
  // ============================================
  delete(positionId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl()}/positions/${positionId}`);
  }
}
